import type { Channel } from '../api/types';
import './ChannelHeader.css';

interface Props {
  channel: Channel;
  isLoggedIn: boolean;
  isSubscribed: boolean;
  onLoginClick: () => void;
}

function formatCategory(category: string): string {
  return category
    .split(/[_-\s]+/)
    .filter(Boolean)
    .map((value) => value.charAt(0).toUpperCase() + value.slice(1))
    .join(' ');
}

export function ChannelHeader({ channel, isLoggedIn, isSubscribed, onLoginClick }: Props) {
  return (
    <section className="channel-header">
      <div className="channel-header-top">
        <div className="channel-header-avatar">
          {channel.creatorAvatar ? (
            <img
              src={channel.creatorAvatar}
              alt={channel.creatorName}
              className="channel-header-avatar-img"
            />
          ) : (
            <div className="channel-header-avatar-fallback" aria-hidden="true">
              {channel.creatorName.slice(0, 1).toUpperCase()}
            </div>
          )}
        </div>

        <div className="channel-header-copy">
          <div className="channel-header-badges">
            <span className="channel-header-badge">{formatCategory(channel.category)}</span>
            {channel.subPrice > 0 ? <span className="channel-header-badge channel-header-badge--premium">Subscriber Only</span> : null}
            {isSubscribed ? <span className="channel-header-badge channel-header-badge--active">Subscribed</span> : null}
          </div>
          <h1 className="channel-header-name">{channel.name}</h1>
          <p className="channel-header-creator">by {channel.creatorName}</p>
          <p className="channel-header-desc">{channel.description || 'No description yet.'}</p>
        </div>
      </div>

      <div className="channel-header-stats">
        <div className="channel-header-stat">
          <strong>{channel.subscriberCount.toLocaleString()}</strong>
          <span>Subscribers</span>
        </div>
        <div className="channel-header-stat">
          <strong>{channel.messageCount.toLocaleString()}</strong>
          <span>Messages</span>
        </div>
        <div className="channel-header-stat">
          <strong>{channel.totalPlays.toLocaleString()}</strong>
          <span>Plays</span>
        </div>
      </div>

      {!isLoggedIn ? (
        <button type="button" className="channel-header-login" onClick={onLoginClick}>
          Login for full access
        </button>
      ) : null}
    </section>
  );
}
